'use client';

import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useLocale, useTranslations } from 'next-intl';

import PageLayout from '@/app/components/PageLayout';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

import { sections } from './data';
import TermsAndConditionsSection from './TermsAndConditionsSection';

const Content = () => {
  const t = useTranslations();
  const locale = useLocale();
  const localePath = getLocalePartialUrl(locale);

  return (
    <PageLayout
      pageName="Terms and Conditions"
      containerProps={{ name: 'terms-and-conditions', padding: 'both' }}
      footerProps={{
        wrapperClassName: 'bg-white',
      }}
    >
      <LayoutGrid data-cy="terms-and-conditions">
        <GridItem colStart={{ sm: 'main' }} colEnd={{ sm: 'main' }}>
          {sections.map((section, index) => (
            <TermsAndConditionsSection
              key={index}
              localePath={localePath}
              {...section}
            />
          ))}
          {/* English Disclaimer */}
          <Typography className="mt-40">
            {t('terms_and_conditions_2025_p71')}
          </Typography>
        </GridItem>
      </LayoutGrid>
    </PageLayout>
  );
};

export default Content;
